/* eslint-disable no-unused-vars */
/*
Format: -
{
    "type":"ContentRow",
    "contents":[
        <object>
    ]
}

Allow content objects: -
- TextInput
- NumberInput
- NumberSpin
- StaticSelect
- ValidSelect
- HtmlTag
- Space
*/

import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { TextInput } from './text-input';
import { HiddenInput } from './hidden-input';
import { DateInput } from './date-input';
import { NumberInput } from './number-input';

import { StaticSelect, ValidSelect } from './zeta-select';
import { ZetaElement } from './zeta-element';
import { NumberSpin } from './number-spin';
import { TextLabel } from './text-label';
import { TextView } from './text-view';
import { ActionButton } from './action-button';

export function ContentRow(props) {
  const { app, em, data, onChange } = props;

  // const handleDefaultClick = useCallback((e) => {});

  return (
    <div className={"row mt-0 px-0" + (em?.class ? ` ${em.class}` : '')}>
      {em &&
        em.contents &&
        em.contents.map((t, i) => {
          const attrs = { ...props, ...t, floating: typeof t.floating === 'undefined' ? true : t.floating };
          delete attrs.em;
          delete attrs.app;
          delete attrs.data;
          // delete attrs.onChange;

          if (typeof t.toggle === 'string' && app && app.attrs && !app.attrs[t.toggle]) {
            return null;
          }

          if (!attrs.class) {
            attrs.class = 'col-sm-4';
          }

          switch (t.type) {
            case 'ActionButton':
              attrs.class = '';
              return <div key={i} className={t.class || 'col-sm-4'}>
                <ActionButton em={attrs} app={app} />
              </div>
              
            case 'TextInput':
              return <TextInput key={i} em={attrs} app={app} data={data} onChange={onChange} />;

            case 'HiddenInput':
              return <HiddenInput key={i} em={attrs} app={app} data={data} />;

            case 'TextLabel':
              return <TextLabel key={i} em={attrs} app={app} data={data} onChange={onChange} />;

            case 'TextView':
              return <TextView key={i} em={attrs} app={app} data={data} onChange={onChange} />;
    
            case 'DateInput':
              return <DateInput key={i} em={attrs} app={app} data={data} onChange={onChange} />;

            case 'NumberInput':
              return <NumberInput key={i} em={attrs} app={app} data={data} onChange={onChange} />;

            case 'NumberSpin':
              return <NumberSpin key={i} em={attrs} app={app} data={data} onChange={onChange} />;
  
            case 'StaticSelect':
              return <StaticSelect key={i} em={attrs} app={app} data={data} onChange={onChange} />;

            case 'ValidSelect':
              return <ValidSelect key={i} em={attrs} app={app} data={data} onChange={onChange} />;

            case 'HtmlTag':
              return <ZetaElement key={i} em={attrs} app={app} data={data} />

            case 'Space':
              return <div key={i} className={`${(t && t.class ? t.class : '')}`}>
                &nbsp;
              </div>
          
            default:
              return null;
          }
        })}
      {props.children}
    </div>
  );
}

ContentRow.propTypes = {
  app : PropTypes.any, 
  em : PropTypes.any, 
  data : PropTypes.any, 
  onChange : PropTypes.func,
  children : PropTypes.any
}